


















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ExchangeRatesShell extends Vue {
  columns = [
    {
      label: 'GENERAL.DATE',
      name: 'date',
      format: (v: Date) => this.$formatDate(v),
    },
    { label: 'GENERAL.CODE', name: 'code', sortable: true },
    { label: 'GENERAL.COMPANY', name: 'rateProvider', sortable: true },
    {
      label: 'GENERAL.COMPANY_DATE',
      name: 'providerDate',
      sortable: true,
      format: (v: Date) => this.$formatDate(v),
    },
    {
      label: 'GENERAL.VALUE',
      name: 'value',
      sortable: true,
      format: (v: number) => `${v}`,
    },
  ];

  get today() {
    return this.$formatDate(new Date(), 'YYYY-MM-DD');
  }
}
